import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import '../../sass/style.scss';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet>
      <title>TUSK, Inc. | Footnotes to Frontrunners.</title>
      <meta name="description" content="We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow." />
      <meta property="og:title" content="New norms. New ideas. New TUSK." />

      <meta property="og:description" content="The rules have changed. So have we. Let’s get started." />
      <meta property="og:site_name" content="TUSK, Inc." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://tuskinc.com/" />
      <meta property="og:image" content="https://tusk-site.netlify.com/OG-FB-TUSK.png" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="New norms. New ideas. New TUSK." />
      <meta name="twitter:url" content="https://tuskinc.com/" />
      <meta name="twitter:description" content="The rules have changed. So have we. Let’s get started." />
      <meta property="twitter:image" content="https://tusk-site.netlify.com/OG-Twitter-TUSK.png" />
    </Helmet>
    {children()}
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js